import { patch, read } from '@/utils/request'
import type { BatchProcessingParams, BatchProcessingRes, DetailWithLogs, ListData } from 'bv-typings'


export type IBlacklistListParams = {
  entityName?: string[]
  limitType: string,
  entityType: string,
  agency: string,
  status: string,
}

export type IBlacklistInfo = {
  id: string
  entityName: string
  limitReason: string
  limitType: number
  entityType: number
  agency: number
  status: number
}

export type IBlacklistListRes = ListData<IBlacklistInfo>

async function getBlacklistList (params?: IBlacklistListParams) {
  return read<IBlacklistListRes> ('policy_insight/black_list', params)
}

export type IBlacklistDetail = {
  entityId: number
} & IBlacklistInfo

async function getBlacklistDetail (id: string) {
  return read<DetailWithLogs<IBlacklistDetail>> ('policy_insight/black_list', undefined, '获取黑名单详情失败', id )
}

export type ISingleEditBlacklistParams = {
  limitType: string
  limitReason: string
  status: string
}

async function singleEditBlacklist (params: ISingleEditBlacklistParams, id?: string) {
  return patch<any> ('policy_insight/black_list', params, '修改失败', id)
}

export type IEditBlacklistParams = Omit<IBlacklistInfo, 'id'>
async function batchEditBlacklist (params: BatchProcessingParams<IEditBlacklistParams>[]) {
  return patch<BatchProcessingRes<IEditBlacklistParams>> ('policy_insight/black_list', params )
}

export {
  getBlacklistList,
  getBlacklistDetail,
  singleEditBlacklist,
  batchEditBlacklist,
}


